module.exports = __webpack_public_path__ + "static/media/notch.393f543f.png";